import { AxiosResponse } from 'axios';

export default (response: AxiosResponse): Array<string> => {
  if (!response.data || response.data.errors === undefined || !response.data.errors) {
    return [];
  }

  const errorsAggregate: Array<string> = [];

  const errorsObject = response.data.errors;

  Object.keys(errorsObject).forEach((errorKey) => {
    const errors = errorsObject[errorKey];

    errors.forEach((error: string) => {
      errorsAggregate.push(error);
    });
  });

  return errorsAggregate;
};
